import React from 'react';

export default function PasskeyIcon({ className = '', title }) {
  return (

<svg
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
    width={23}
    height={23}
  >
    <path
      d="M7.08739 0.6875C1.48788 0.6875 0.687515 0.687402 0.6875 7.03219"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
    />
    <path
      d="M7.08739 23.6875C1.48788 23.6875 0.687515 23.6876 0.6875 17.3428"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
    />
    <path
      d="M17.2876 0.6875C22.8871 0.6875 23.6875 0.687402 23.6875 7.03219"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
    />
    <path
      d="M17.2876 23.6875C22.8871 23.6875 23.6875 23.6876 23.6875 17.3428"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
    />
    <path
      d="M7.08789 9.01465V10.7991M17.2877 9.01465V10.7991M12.6878 9.01465V13.3766C12.6878 13.8393 12.3278 14.7645 10.8878 14.7645M8.28787 17.5403C8.68786 18.0691 10.0478 19.1265 12.2878 19.1265C14.5278 19.1265 15.7544 18.0691 16.0877 17.5403"
      stroke="currentColor"
      strokeWidth="1.375"
      strokeLinecap="round"
    />
  </svg>

  );
}

